import * as types from '../actions/actionTypes';

const initialState = {
  filters: {},
  pagination: {
    page: 1,
    limit: 20,
  },
  alerts: [],
  loading: false,
};

const uiReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.SET_FILTERS:
      return {
        ...state,
        filters: { ...state.filters, ...action.payload },
        pagination: { ...state.pagination, page: 1 }, // Reset to first page on filter change
      };
    case types.CLEAR_FILTERS:
      return {
        ...state,
        filters: {},
        pagination: { ...state.pagination, page: 1 },
      };
    case types.SET_PAGINATION:
      return {
        ...state,
        pagination: { ...state.pagination, ...action.payload },
      };
    case types.SHOW_ALERT:
      return {
        ...state,
        alerts: [...state.alerts, action.payload],
      };
    case types.HIDE_ALERT:
      return {
        ...state,
        alerts: state.alerts.filter((alert) => alert.id !== action.payload),
      };
    case types.SET_LOADING:
      return {
        ...state,
        loading: action.payload,
      };
    default:
      return state;
  }
};

export default uiReducer;